import { Wrapper, PersonMissingStyled } from "./styled";

export const PersonMissingPoster = () => (
  <Wrapper>
    <PersonMissingStyled />
  </Wrapper>
);
